<div class="container">
  <app-text-card spacing="small">
    <p>
      {{
        'In this table you can search for resources such as Teams, SharePoint sites, servers and Business Bookings calendars by Displayname. It displays the Primary and Secondary Owners of Resources. Resources connected to RIS Projects are not shown in the table. If there is a resource where you think someone else should be set as Primary or Secondary Owner then you can contact the Primary Owner.'
          | translate
      }}
    </p>
  </app-text-card>

  <app-status-bar
    type="info"
    icon="../../assets/icons/Information-Circle--Streamline-Ultimate.svg"
  >
    <span>{{ 'The displayed data is updated hourly.' | translate }}</span>
  </app-status-bar>

  <form [formGroup]="filterMenu" class="filterOption">
    <mat-form-field class="filterMenu">
      <mat-label>{{ 'Search resources' | translate }}</mat-label>
      <input
        matInput
        id="input"
        type="text"
        formControlName="search"
        (keydown.enter)="filterSearch()"
        #input
      />
      <button
        matSuffix
        mat-icon-button
        aria-label="Search"
        (click)="filterSearch()"
      >
        <img
          src="../../assets/icons/Search--Streamline-Ultimate.svg"
          alt="Search"
        />
      </button>
    </mat-form-field>

    <button
      mat-flat-button
      color="primary"
      class="filterMenu"
      (click)="clearFilter()"
    >
      {{ 'Clear' | translate }}
    </button>
  </form>

  <div
    *ngIf="dataIsLoaded && tableDataSource.filteredData.length === 0"
    class="emptyBernieContainer"
  >
    <img class="emptyBernieImg" src="../../assets/images/BernieEmptyBox.png" />
    <p class="emptyBernieText" *ngIf="tableDataSource.data.length === 0">
      {{ 'No resources found.' | translate }}
    </p>
  </div>
  <div class="table">
    <div
      class="mat-elevation-z8"
      *ngIf="tableDataSource.filteredData.length > 0"
    >
      <table
        mat-table
        [dataSource]="tableDataSource"
        matSort
        class="mat-elevation-z8"
      >
        <ng-container matColumnDef="resourceType">
          <th mat-header-cell *matHeaderCellDef>{{ 'Type' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <span class="icons-container">
              <img
                *ngIf="element.resourceType === ResourceTypes.TEAM"
                class="typeIcon"
                src="../../assets/images/MSTeamsIcon.svg"
              />
              <img
                *ngIf="element.resourceType === ResourceTypes.SHAREPOINT"
                class="typeIcon"
                src="../../assets/images/SharePointIcon.svg"
              />
              <img
                *ngIf="element.resourceType === ResourceTypes.SERVER"
                class="typeIcon"
                src="../../assets/images/ServerIcon.svg"
              />
              <img
                *ngIf="element.resourceType === ResourceTypes.BOOKINGS"
                class="typeIcon"
                src="../../assets/images/BookingsIcon.svg"
              />
              <img
                *ngIf="element.resourceType === ResourceTypes.SHAREPOINT"
                (click)="openInNewTab(element.url)"
                class="linkIcon"
                [matTooltip]="'Open SharePoint Site' | translate"
                src="../../assets/icons/Share-External-Link-1--Streamline-Ultimate.svg"
              />
              <!-- The booking page only exists when the business was published -->
              <img
                *ngIf="
                  element.resourceType === ResourceTypes.BOOKINGS && element.url
                "
                (click)="openInNewTab(element.url)"
                class="linkIcon"
                [matTooltip]="'Open booking page' | translate"
                src="../../assets/icons/Share-External-Link-1--Streamline-Ultimate.svg"
              />
              <!--                    <img *ngIf="element.resourceType === ResourceTypes.RIS" class="bfhIcon"-->
              <!--                         src="../../assets/images/BFHIcon.png">-->
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="displayName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'Name' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <span [matTooltip]="element.displayName">{{
              element.displayName
            }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="primaryOwner">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'Primary Owner' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.primaryOwner }}</td>
        </ng-container>

        <ng-container matColumnDef="secondaryOwner">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'Secondary Owner' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.secondaryOwner }}
          </td>
        </ng-container>

        <ng-container matColumnDef="resourceStatus">
          <th mat-header-cell *matHeaderCellDef>{{ 'Status' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            {{ element.resourceStatus | translate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="endOfLife">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'Lifecycle end' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.endOfLife | date: 'dd.MM.yyyy' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
        <tr
          mat-row
          (click)="clickedRow(row)"
          [class.clickedRow]="selectedRow === row"
          *matRowDef="let row; columns: tableColumns"
        ></tr>
      </table>
      <mat-paginator
        *ngIf="tableDataSource.filteredData.length > 0"
        [pageSize]="10"
        [pageSizeOptions]="[10, 30, 50]"
        showFirstLastButtons
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
